import { useRef, useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import styles from './project-networks.module.css'; // Use CSS modules
import SocialMessageBox from '../shared/SocialMessageBox';
import MessageBox from '../shared/MessageBox';
import defaultProfile2 from '../images/default-profile2.jpg';
import Notification from '../shared/Notification';
import { useAuth } from '../context/AuthContext';
import { io } from 'socket.io-client';


const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-e45c.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});

const ProjectNetworks = () => {
    const [discipline, setDiscipline] = useState('');
    const [name, setName] = useState('');
    const { userId } = useAuth();
    const [profilePicture, setProfilePicture] = useState('');
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    const [encourageReceived, setEncourageReceived] = useState([]);
    const [encourageSent, setEncourageSent] = useState([]);
    const [declinePolitely, setDeclinePolitely] = useState([]);
    const [declineHarshly, setDeclineHarshly] = useState([]);
    const [availableFreshNetworks, setAvailableFreshNetworks] = useState([]);
    const [notification, setNotification] = useState('');
    const [reload, setReload] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [selectedNetworks, setSelectedNetworks] = useState([]);
    const [showGroupCreation, setShowGroupCreation] = useState(false);
    const [myGroups, setMyGroups] = useState([]);
    const [activeGroupChat, setActiveGroupChat] = useState(null);
    const [socialType, setSocialType] = useState('');
    const [activeMessageBox, setActiveMessageBox] = useState(null);
    // const [profileData, setProfileData] = useState(null);
    // const [prevNetworkId, setPrevNetworkId] = useState(null);
    const [status, setStatus] = useState('');
    const pnRef = useRef(null);
    const navigate = useNavigate();
    const [myClubs, setMyClubs] = useState([]);
    const [myChannels, setMyChannels] = useState([]);
    const createGroupRef = useRef(null);
    const token = useMemo(() => localStorage.getItem('token'), []);
    const [allClubs, setAllClubs] = useState([]);
    const [allChannels, setAllChannels] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/login');
                    return;
                }

                const response = await axios.get('/api/pn/all-networks', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log(response.data);
                const { discipline, name, profilePicture, projectNetworkList, encourageReceived, encourageSent, declinePolitely, declineHarshly, availableFreshNetworks } = response.data.pnLists;
                setDiscipline(discipline);
                setName(name);
                setProfilePicture(profilePicture);
                setProjectNetworkList(projectNetworkList);
                setEncourageReceived(encourageReceived);
                setEncourageSent(encourageSent);
                setDeclinePolitely(declinePolitely);
                setDeclineHarshly(declineHarshly);
                setAvailableFreshNetworks(availableFreshNetworks);
                // console.log('Discipline:', discipline);
                // console.log('Name:', name);
                // console.log('Profile Picture:', profilePicture);
                // console.log('Project Network List:', projectNetworkList);
                // console.log('Encourage Received:', encourageReceived);

                // console.log('Encourage Sent:', encourageSent);
                // console.log('Decline Politely:', declinePolitely);
                // console.log('Decline Harshly:', declineHarshly);
                // console.log('Available Fresh Networks:', availableFreshNetworks);
            } catch (error) {
                // const errorMessage = error.response?.data?.message || 'Error fetching project networks data';
                // console.error(errorMessage);
                if(error.response?.data?.message=='jwt expired') {
                    // localStorage.setItem('notification', 'Session expired. Please log in again.');
                    setNotification( 'Session expired. Please log in again.');
                    // navigate('/login');
                }
                else {
                    setNotification(error.response?.data?.message ||'Error fetching project networks data1. Please try again.');
                }
            }
        };

        if (reload) {
            window.location.reload();
        }
        fetchData();
    }, [navigate, reload]);

    useEffect(() => {
        const fetchClubsAndChannels = async () => {
            try {
                const response = await axios.get('/api/pn/all-clubs-channels', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setAllClubs(response.data.clubs || []);
                setAllChannels(response.data.channels || []);
                // console.log("respose.data.applicant:",response.data.applicant);
                // console.log('All Clubs:', response.data.clubs);
                // console.log('All Channels:', response.data.channels);
                // console.log('Applicant:', response.data.applicant);
            } catch (error) {
                // console.error('Error fetching user clubs and channels:', error.message);
            }
        };

        fetchClubsAndChannels();
    }, []);

    useEffect(() => {
        const fetchGroupsChannelsClubs = async () => {
            try {
                const response = await axios.get('/api/pn/my-groups-clubs-channels', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMyGroups(response.data.groups);
                setMyClubs(response.data.clubs);
                setMyChannels(response.data.channels);
                // console.log('My Channels:', response.data.channels);
                // console.log('My Groups:', response.data.groups);
                // console.log('My Clubs:', response.data.clubs);
            } catch (error) {
                // console.error('Error fetching user groups:', error.message);
            }
        };

        fetchGroupsChannelsClubs();
    }, []);

    useEffect(() => {
        const handleGroupSort = ({ socialId, createdAt }) => {
            setMyGroups(prev => {
                // Check if group exists
                const groupExists = prev.some(g => g._id === socialId);
                if (!groupExists) return prev;

                // Update and sort
                return [...prev]
                    .map(g =>
                        g._id === socialId
                            ? { ...g, lastMessageCreatedAt: createdAt }
                            : g
                    )
                    .sort((a, b) => {
                        const dateA = new Date(a.lastMessageCreatedAt || 0);
                        const dateB = new Date(b.lastMessageCreatedAt || 0);
                        return dateB - dateA; // Descending order (latest first)
                    });
            });
        };

        socket.on('groupLastMessageUpdate', handleGroupSort);
        return () => socket.off('groupLastMessageUpdate', handleGroupSort);
    }, []);
    
    useEffect(() => {
        const handleClubSort = ({ socialId, createdAt }) => {
            setMyClubs(prev => {
                // Check if Club exists
                const clubExists = prev.some(g => g._id === socialId);
                if (!clubExists) return prev;

                // Update and sort
                return [...prev]
                    .map(g =>
                        g._id === socialId
                            ? { ...g, lastMessageCreatedAt: createdAt }
                            : g
                    )
                    .sort((a, b) => {
                        const dateA = new Date(a.lastMessageCreatedAt || 0);
                        const dateB = new Date(b.lastMessageCreatedAt || 0);
                        return dateB - dateA; // Descending order (latest first)
                    });
            });
        };

        socket.on('clubLastMessageUpdate', handleClubSort);
        return () => socket.off('clubLastMessageUpdate', handleClubSort);
    }, []);

    useEffect(() => {
        const handleChannelSort = ({ socialId, createdAt }) => {
            setMyChannels(prev => {
                // Check if channel exists
                const channelExists = prev.some(g => g._id === socialId);
                if (!channelExists) return prev;
                // Update and sort
                return [...prev]
                    .map(g =>
                        g._id === socialId
                            ? { ...g, lastMessageCreatedAt: createdAt }
                            : g
                    )
                    .sort((a, b) => {
                        const dateA = new Date(a.lastMessageCreatedAt || 0);
                        const dateB = new Date(b.lastMessageCreatedAt || 0);
                        return dateB - dateA; // Descending order (latest first)
                    });
            });
        };

        socket.on('channelLastMessageUpdate', handleChannelSort);
        return () => socket.off('channelLastMessageUpdate', handleChannelSort);
    }, []);
    

    const handleEncourage = async (event, networkId) => {
        event.stopPropagation();
        try {
            await axios.post('/api/pn/encouraged', { networkId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification('Encouragement sent successfully!');
            setEncourageSent([...encourageSent, networkId]);
            setAvailableFreshNetworks(availableFreshNetworks.filter(network => network._id !== networkId));
            setReload(true);
        } catch (error) {
            // console.error('Error sending encouragement:', error);
            setNotification('Error sending encouragement. Please try again.');
        }
    };

    const handleEncourageSupport = async (event,networkId) => {
        event.stopPropagation();
        try {
            await axios.post('/api/pn/encourage-support', { networkId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification('Encouragement supported successfully!');
            setEncourageReceived(encourageReceived.filter(network => network._id !== networkId));
            setAvailableFreshNetworks(projectNetworkList.filter(network => network._id !== networkId));
            setReload(true);
        } catch (error) {
            // console.error('Error supporting encouragement:', error.message);
            setNotification('Error supporting encouragement. Please try again.');
        }
    };
    const handleRemoveNetwork = async (event, networkId) => {
        event.stopPropagation();
        try {
            await axios.post('/api/pn/remove-network', { networkId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification('Network Removed!');
            setProjectNetworkList([...availableFreshNetworks, { _id: networkId }]);
            // setRemoveFriendText(' 😢 Removed!');
            setReload(true);
        } catch (error) {
            // console.error('Error network removing:', error);
            setNotification('Error network removing. Please try again.');
        }
    };

    const handleDiscourage = async (event, networkId, type) => {
        event.stopPropagation();
        try {
            await axios.post('/api/pn/discouraged', { networkId, type }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setNotification(`Encouragement ${type === 'polite' ? 'declined politely' : 'declined harshly'}.`);
            setEncourageReceived(encourageReceived.filter(network => network._id !== networkId));
            if (type === 'polite') {
                setDeclinePolitely([...declinePolitely, { _id: networkId, name: "Unknown" }]);
            } else {
                setDeclineHarshly([...declineHarshly, { _id: networkId, name: "Unknown" }]);
            }
        } catch (error) {
            // console.error('Error declining encouragement:', error);
        }
    };

    const handleCreateGroup = async () => {
        try {
            const response = await axios.post('/api/group/create-group', {
                groupName,
                userIds: selectedNetworks
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                 setNotification(response.data.message || 'Group created successfully!');
                setGroupName('');
                setSelectedNetworks([]);
                setShowGroupCreation(false);
            }
        } catch (error) {
            // console.error('Error creating group:', error);
            const errorMessage = error.response?.data?.message || 'Error creating group. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleSelectNetwork = async (event, networkId) => {
        event.stopPropagation();
        setSelectedNetworks((prevSelected) => {
            if (prevSelected.includes(networkId)) {
                return prevSelected.filter(id => id !== networkId);
            } else {
                return [...prevSelected, networkId];
            }
        });
    };

    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleShowGroupCreation = () => {

        if (createGroupRef.current&&!showGroupCreation) {
            createGroupRef.current.scrollIntoView({ behavior: 'smooth' });
        }

        if(showGroupCreation) {
            setShowGroupCreation(false);
        } else {
            setShowGroupCreation(true);
        }
    };

    const handleMessage = async (event, network) => {
        event.stopPropagation();
        // console.log('Clicked network:', network);
        // console.log('  activeMessageBox :', activeMessageBox);
        if (activeMessageBox?._id === network._id) {
        // Same user clicked again, toggle off
        setActiveMessageBox(null);
    } else {
        // Different user clicked
        setActiveMessageBox(null); // Force close old one
        setTimeout(() => {
            setActiveMessageBox(network); // Then open new one
        }, 0);
    }

    };
    const handleGroupChatClick = async (group) => {
        // console.log('group:', group);
        setSocialType('group');
        if (activeGroupChat?._id === group._id) {
            setActiveGroupChat(null);
        } else {
            setActiveGroupChat(group);
        }
    };
    const handleClubChatClick = async (club) => {
        // console.log('group:', group);
        setSocialType('club');
        if (activeGroupChat?._id === club._id) {
            setActiveGroupChat(null);
        } else {
            setActiveGroupChat(club);
        }
    };
    const handleChannelChatClick = async (channel) => {
        // console.log('group:', group);
        setSocialType('channel');
        if (activeGroupChat?._id === channel._id) {
            setActiveGroupChat(null);
        } else {
            setActiveGroupChat(channel);
        }
    };

    const handleCloseMessageBox = () => {
        setActiveMessageBox(null);
    };
    const handleCloseChat = () => {
        setActiveGroupChat(null);
    };

    const handleScrollToPN = () => {
        if (pnRef.current) {
            pnRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    
    const handleGroupsClick = () => {
        navigate('/groups');
    }
    const handleChannelsClick = () => {
        navigate('/channels');
    }
    const handleClubsClick = () => {
        navigate('/clubs');
    }
    const handleChannelClick = (channelId) => {
        navigate('/channel/' + channelId);
    }
    const handleClubClick = (clubId) => {
        navigate('/club/' + clubId);
    }

    const handleProfileClick = async (event, networkId) => {
        event.stopPropagation();
        const profileStatus = projectNetworkList.some(n => n._id === networkId) ? 'friends' :
        encourageReceived.some(n => n._id === networkId) ? 'received' :
        encourageSent.some(n => n._id === networkId) ? 'sent' :
        declinePolitely.some(n => n._id === networkId) ? 'declined-politely' :
        declineHarshly.some(n => n._id === networkId) ? 'declined-harshly' :
        availableFreshNetworks.some(n => n._id === networkId) ? 'fresh' : 'unknown';
        // console.log("profileStatus:hp", profileStatus);
        setStatus(profileStatus)
        // console.log("status:hp",status)
        navigate(`/profile/${networkId}`, { state: profileStatus });  
    };

    return (
        <>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <header className={styles.headerContainer}>
            <div className={styles.headerContent}>
                <div className={styles.titleSection}>
                    <h1 className={styles.mainTitle}>
                        ✨ Welcome to Project Networks! ✨
                    </h1>
                    <div className={styles.tagline}>
                        <span className={styles.taglineText}>Create. Collaborate. Innovate.</span>
                    </div>
                </div>

                <div className={styles.heroSection}>
                    <div className={styles.heroImageContainer}>
                        <div className={styles.heroImage}>
                            <div className={styles.collaborationIcon}>🤝</div>
                            <div className={styles.techIcon}>💻</div>
                            <div className={styles.networkIcon}>🌐</div>
                            <div className={styles.innovationIcon}>💡</div>
                        </div>
                    </div>
                    
                    <div className={styles.heroText}>
                        <p className={styles.welcomeMessage}>
                            Got no social groups? Don't worry, we got you covered! 
                            <span className={styles.highlight}> Join groups now to:</span>
                        </p>
                        
                        <div className={styles.featuresGrid}>
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>🚀</div>
                                <div className={styles.featureContent}>
                                    <h3>DO PROJECTS</h3>
                                    <p>Collaborate on exciting projects with like-minded individuals and bring your ideas to life!</p>
                                </div>
                            </div>
                            
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>📚</div>
                                <div className={styles.featureContent}>
                                    <h3>LEARN</h3>
                                    <p>Acquire new skills and knowledge from experts and peers in a supportive environment.</p>
                                </div>
                            </div>
                            
                            <div className={styles.feature}>
                                <div className={styles.featureIcon}>🎯</div>
                                <div className={styles.featureContent}>
                                    <h3>TEACH</h3>
                                    <p>Share your expertise and help others grow and develop their skills.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

               <div className={styles.benefitsSection}>
                    <h2 className={styles.benefitsTitle}>🌟 Our Project Networks is perfect for you to: 🌟</h2>
                    <div className={styles.benefitsList}>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>💫</span>
                            <span>Connect with people who share similar interests and passions</span>
                        </div>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>🎨</span>
                            <span>Develop new skills and enhance your professional portfolio</span>
                        </div>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>🤝</span>
                            <span>Build meaningful relationships and networks</span>
                        </div>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>📈</span>
                            <span>Stay updated with the latest trends and technologies</span>
                        </div>
                    </div>
                </div>

                <div className={styles.ctaSection}>
                    <p className={styles.ctaText}>
                        Join us today and become a part of a dynamic and innovative community 
                        that is shaping the future of collaboration and project management!
                    </p>
                    <button className={styles.ctaButton} onClick={handleScrollToPN}>
                        🎊 Join Amazing Community! 🎊
                    </button>
                </div>
            </div>
        </header>
            <div ref={pnRef} className={styles.projectNetworksContainer}>
                
                {/* Emotional status banner */}
                <div className={styles.emotionalStatusBanner}>
                    <p>You have {projectNetworkList?.length || 0} amazing connections! Embrace them</p>
                </div>

                <div className={styles.profileSection}>
                    <img title={name}
                        src={profilePicture? profilePicture.replace('/upload/', '/upload/f_auto,q_auto:eco,w_384,h_400,c_fill,g_face/'):    defaultProfile2}
                        alt="pfp" 
                        className={styles.profilePicture} 
                        loading="lazy"         
                        decoding="async"
                    />
                    <div className={styles.profileInfo}>
                        <h2>{name} ✨</h2>
                        {/* <p>{discipline}</p> */}
                        <p className={styles.socialStatus}>🌟Quote of the day 🌟</p>
                    </div>
                </div>
                
                <div className={styles.mainContent}>
                    <div className={styles.leftColumn}>
                        {(projectNetworkList || projectNetworkList.length !== 0) && (
                            <div ref={createGroupRef} className={`${styles.networksSection} ${styles.pnGroup}`}>
                                <h3>{showGroupCreation? "Add Friends": "Friends List"}</h3>
                                {!showGroupCreation&&<p className={styles.sectionSubtext}>Collaborate, Learn & Grow together!</p>}
                                <ul>
                                    {projectNetworkList?.map(network => (
                                        !showGroupCreation ? (
                                            <li key={network._id} className={styles.networkItem} onClick={(e) => handleProfileClick(e, network._id)}>
                                                <div className={styles.networkInfo} >
                                                    <span className={styles.networkName}>💫 {network.name} 💫</span>
                                                    {/* <span className={styles.connectionTime}>{network.skills}</span> */}
                                                </div>
                                                <div className={styles.networkActions}>
                                                    <button onClick={(e) => handleMessage(e, network)} className={styles.primaryAction}>
                                                        💬 Say Hi!
                                                    </button>
                                                    <button onClick={(e) => handleRemoveNetwork(e,network._id)} className={styles.secondaryAction}>
                                                        😢 Remove (We'll miss them!)
                                                    </button>
                                                </div>
                                            </li>
                                            ) : (
                                            <li key={network._id} className={styles.networkItem} onClick={(e) => handleSelectNetwork(e, network._id)}>
                                                <div className={styles.networkInfo} >
                                                    <span className={styles.networkName}>💫 {network.name} 💫</span>
                                                    {/* <span className={styles.connectionTime}>{network.skills}</span> */}
                                                </div>
                                                <input type="checkbox" checked={selectedNetworks.includes(network._id)}/>
                                            </li>
                                            )
                                        ))
                                    }
                                </ul>
                                {/* {(!projectNetworkList || projectNetworkList.length === 0) && (
                                <div className={styles.emptyState}>
                                    <p>🥺 No connections yet? Let's find some amazing people to connect with! 🥺</p>
                                </div> 
                                )} */}
                            </div>
                            )}
                        {activeMessageBox && (
                            <MessageBox activeChat={activeMessageBox} userId={userId}
                            status={status}
                            onClose={handleCloseMessageBox}/>
                        )}

                        {(!encourageSent || encourageSent.length !== 0) &&(!showGroupCreation) && (
                            <div className={`${styles.encourageSentSection} ${styles.pnGroup}`}>
                                <h3>Sent Requests</h3>
                                <p className={styles.sectionSubtext}>Just Move On, Older Requests are erased automatcally(in 3 weeks)</p>
                                <ul>
                                    {encourageSent?.map(network => (
                                        <li key={network._id} className={styles.sentItem} onClick={(e) => handleProfileClick(e, network._id)}>
                                            <span className={styles.sentName}>⏰ {network.name}</span>
                                            <span className={styles.sentStatus}>Waiting for their response... 🤞</span>
                                        </li>
                                    ))}

                                    {/* {(!encourageSent || encourageSent.length === 0) && (
                                        <div className={styles.emptyState}>
                                            <p>Just Move On, Older Requests are erased automatcally(3 weeks)</p>
                                        </div>
                                    )} */}
                                </ul>
                            </div>
                        )}

                        <div className={`${styles.createGroupSection} ${styles.pnGroup}`}>
                            <h3>Create Your Group!</h3>
                            <p className={styles.sectionSubtext}>Bring Friends together</p>
                            {/* <p className={styles.sectionSubtext}>Draw friends Closer</p> */}
                            {!showGroupCreation && <button onClick={handleShowGroupCreation} className={styles.primaryAction}>
                                Create New Group
                            </button>}
                            {showGroupCreation && (
                                <div className={styles.groupCreationForm}>
                                    <h4>Select Your Friends to Make Group </h4>
                                    {/* <h4>🌈 Give Your Group a Special Name 🌈</h4> */}
                                    <input
                                        type="text"
                                        value={groupName}
                                        onChange={(e) => setGroupName(e.target.value)}
                                        placeholder="Set Group Name"
                                        className={styles.groupNameInput}
                                    />
                                    <button onClick={handleCreateGroup} className={styles.createButton}>
                                        🎊 Create Group! 🎊
                                    </button>
                                    <button onClick={handleShowGroupCreation} className={styles.closeCreateGroupButton}>Cancel
                                    </button>
                                </div>
                            )}
                        </div>

                        {(!myGroups || myGroups?.length !== 0) && (
                            <div className={`${styles.myGroupsSection} ${styles.pnGroup}`}>
                                <h3 className={styles.groupHeading} onClick={() => handleGroupsClick()} >👥Groups👥 ({myGroups?.length})</h3>
                                <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                                <ul>
                                    {myGroups?.map(group => (
                                        <li key={group._id} onClick={() => handleGroupChatClick(group)} className={styles.groupItem}>
                                            <span className={styles.groupName}>🌟 {group.name} 🌟</span>
                                            {/* <span className={styles.groupMembers}>{group.participantCount} members</span> */}
                                            <div className={styles.groupActivity}>
                                                <span className={styles.activityIndicator}>💚 Active now!</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                {(!myGroups || myGroups?.length === 0) && (
                                    <div className={styles.emptyState}>
                                        <p>🌱 No groups yet? Create your first one and watch the magic happen! 🌱</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {activeGroupChat && (
                            <SocialMessageBox socialType={socialType} social={activeGroupChat} onClose={handleCloseChat} />
                        )}

                    </div>
                    <div className={styles.rightColumn}>

                        {(!encourageReceived || encourageReceived.length !== 0) && (
                            <div className={`${styles.encourageReceivedSection} ${styles.pnGroup}`}>
                                <h3>Received Friend Requests</h3>
                                {/* <p className={styles.sectionSubtext}>Look how popular you are! They're waiting for your response 🥰</p> */}
                                <ul>
                                    {encourageReceived?.map(network => (
                                        <li key={network._id} className={styles.encourageItem} onClick={(e) => handleProfileClick(e, network._id)}>
                                            <div className={styles.encourageInfo}>
                                                <span className={styles.encouragerName}>💕 {network.name} 💕</span>
                                                <span className={styles.encourageMessage}>is excited to connect with you!</span>
                                            </div>
                                            <div className={styles.encourageActions}>
                                                <button onClick={(e) => handleEncourageSupport(e, network._id)} className={styles.acceptButton}>
                                                    🎉 Yes! Let's Connect! 🎉
                                                </button>
                                                <button onClick={(e) => handleDiscourage(e, network._id, 'polite')} className={styles.politeDecline}>
                                                    {/* 😊 Maybe Later, */}
                                                     Decline Politely
                                                </button>
                                                <button onClick={(e) => handleDiscourage(e, network._id, 'harsh')} className={styles.harshDecline}>
                                                    {/* 😔 Not Right Now, */}
                                                     Decline Harshly
                                                </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                {/* {(!encourageReceived || encourageReceived.length === 0) && (
                                    <div className={styles.emptyState}>
                                        <p>🌟 No new connection requests right now, but keep being amazing! 🌟</p>
                                    </div>
                                )} */}
                            </div>
                        )}

                        <div className={`${styles.availableFreshNetworksSection} ${styles.pnGroup}`}>
                            <h3>New Friends</h3>
                            <p className={styles.sectionSubtext}>New Skills & Friends waiting</p>
                            <ul>
                                {availableFreshNetworks?.map(network => (
                                    <li key={network._id} className={styles.freshNetworkItem}>
                                        <div onClick={(e) => handleProfileClick(e, network._id)}>
                                        <img title={network.name}
                                        src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}
                                        alt="pfp" className={styles.networkProfilePicture} />
                                        <div className={styles.freshNetworkInfo}>
                                            <span className={styles.freshNetworkName}>✨ {network.name} ✨</span>
                                            {/* <span className={styles.freshNetworkMeta}>New member • {Math.floor(Math.random() * 100) + 1}% compatibility!</span> */}
                                            {/* <span className={styles.freshNetworkMeta}>{network.skills}</span> */}
                                        </div>
                                        <button onClick={(e) => handleEncourage(e, network._id)} className={styles.encourageButton}>
                                            Let's Connect!
                                        </button>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            {(!availableFreshNetworks || availableFreshNetworks.length === 0) && (
                                <div className={styles.emptyState}>
                                    <p>🔄 Check back soon! New amazing people join every day! 🔄</p>
                                </div>
                            )}
                        </div>

                        {(!declinePolitely || declinePolitely.length !== 0) && (
                            <div className={`${styles.declinePolitelySection} ${styles.pnGroup}`}>
                                <h3>Declined Politely(To be erased Soon)</h3>
                                <ul>
                                    {declinePolitely?.map(network => (
                                        <li key={network._id} className={styles.declineItem}>
                                            <span>💛 {network.name} 💛</span>
                                            {/* <span className={styles.declineNote}>Perhaps they'll be ready soon! 🌸</span> */}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {(!declineHarshly || declineHarshly.length !== 0) && (
                            <div className={`${styles.declineHarshlySection} ${styles.pnGroup}`}>
                                <h3>Declined Harshly(To be erased Soon)</h3>
                                <ul>
                                    {declineHarshly?.map(network => (
                                        <li key={network._id} className={styles.declineItem}>
                                            <span>🌻 {network.name} 🌻</span>
                                            {/* <span className={styles.declineNote}>We respect their choice! 🕊️</span> */}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {(!myClubs || myClubs?.length !== 0) && (
                            <div className={`${styles.myGroupsSection} ${styles.pnGroup}`} >
                                <h3 onClick={() => handleClubsClick()}>👥Clubs👥 ({myClubs?.length})</h3>
                                <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                                <ul>
                                    {myClubs?.map(club => (
                                        <li key={club._id} onClick={() => handleClubChatClick(club)} className={styles.groupItem}>
                                            <span className={styles.groupName}>🌟 {club.name} 🌟</span>
                                            {/* <span className={styles.groupMembers}>{club.memberCount} members</span> */}
                                            <div className={styles.groupActivity}>
                                                <span className={styles.activityIndicator}>💚 Active now!</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul> 
                            </div>
                        )}

                        {(myClubs.length === 0 && allClubs?.length !== 0) && (
                            <div className={`${styles.myGroupsSection} ${styles.pnGroup}`} >
                                <h3 onClick={() => handleClubsClick()}>👥Explore Clubs👥({allClubs?.length})</h3>
                                <p className={styles.sectionSubtext}>Discover and Join Exciting Clubs!</p>
                                <ul>
                                    {allClubs?.map(club => (
                                        <li key={club._id} onClick={() => handleClubClick(club._id)} className={styles.groupItem}>
                                            <span className={styles.groupName}>🌟 {club.name} 🌟</span>
                                            <span className={styles.groupMembers}>{club.participants?.length} members</span>
                                            <div className={styles.groupActivity}>
                                                <span className={styles.activityIndicator}>💚 Active now!</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* {(!allClubs || allClubs?.length === 0) && (
                            <div className={styles.emptyState}  onClick={() => handleClubsClick()}>
                                <p>🌱 No Club yet? Create your first one and watch the magic happen! 🌱</p>
                            </div>
                        )} */}

                        {(!myChannels || myChannels?.length !== 0) && (
                            <div className={`${styles.myGroupsSection} ${styles.pnGroup}`}>
                                <h3 onClick={() => handleChannelsClick()}>👥Channels👥 ({myChannels?.length !== 0 && myChannels?.length})</h3>
                                <p className={styles.sectionSubtext}>Calling Features Soon!</p>
                                <ul>
                                    {myChannels?.map(channel => (
                                        <li key={channel._id} onClick={() => handleChannelChatClick(channel)} className={styles.groupItem}>
                                            <span className={styles.groupName}>🌟 {channel.name} 🌟</span>
                                            {/* <span className={styles.groupMembers}>{channel.participantCount} members</span> */}
                                            <div className={styles.groupActivity}>
                                                <span className={styles.activityIndicator}>💚 Active now!</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )} 
                        
                        {(myChannels.length === 0 && allChannels?.length !== 0) && (
                            <div className={`${styles.myGroupsSection} ${styles.pnGroup}`} >
                                <h3 onClick={() => handleClubsClick()}>👥Explore Channels👥({allChannels?.length})</h3>
                                <p className={styles.sectionSubtext}>Discover and Join Exciting Channels!</p>
                                <ul>
                                    {allChannels?.map(channel => (
                                        <li key={channel._id} onClick={() => handleChannelClick(channel._id)} className={styles.groupItem}>
                                            <span className={styles.groupName}>🌟 {channel.name} 🌟</span>
                                            <span className={styles.groupMembers}>{channel.participants?.length} members</span>
                                            <div className={styles.groupActivity}>
                                                <span className={styles.activityIndicator}>💚 Active now!</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>

                {/* Persistent motivation footer */}
                <div className={styles.motivationFooter}>
                    <p>UI encourages to Find Friends and learn skills on Project Networks ! </p>
                    <p>Sharing is Caring! </p>
                </div>
            </div>
        </>
    );
};

export default ProjectNetworks;

// handleEncourageSupport
// handleEncourage